module.exports = __webpack_public_path__ + "static/media/img7.7bedbd6a.png";